<div class="instance-management">
  <p-tabs [(value)]="activeTab" styleClass="instance-management__tabs">
    <p-tablist>
      <p-tab [value]="freeSwitchTab">
        {{ 'FreeswitchIntegration::FreeSwitchInstances' | abpLocalization }}
      </p-tab>
      <p-tab [value]="ivrTab">
        {{ 'FreeswitchIntegration::IvrInstances' | abpLocalization }}
      </p-tab>
    </p-tablist>

    <p-tabpanels>
      <p-tabpanel [value]="freeSwitchTab">
        <app-freeswitch-integration-main />
      </p-tabpanel>
      <p-tabpanel [value]="ivrTab">
        <app-ivr-instance-main />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
